// extracted by mini-css-extract-plugin
export default {"heading":"heading__NzRjZ","strong":"strong__OGZhZ","h1":"h1__ZGFmM","h2":"h2__ZTQ4M","h3":"h3__YjM3Z","h4":"h4__MTQ5O","h5":"h5__MGY5Y","h6":"h6__N2ViM"};